import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterDTOType } from '../../schemas';
import type { RootState } from '../store';

interface IProductsState {
  activeFilters: Array<FilterDTOType>;
}

const initialState: IProductsState = {
  activeFilters: [],
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{
        field: string;
        values: Array<string>;
        filterType?: string;
      }>,
    ) => {
      const { field, values, filterType } = action.payload;

      state.activeFilters = state.activeFilters.filter(f => f.field !== field);

      if (values.length > 0) {
        let type = filterType ? filterType : values.length === 1 ? 'EQ' : 'IN';

        if (field === 'variants.aiTags' || field === 'productTypeId') {
          type = 'IN';
        }

        const value = values.join(',');

        state.activeFilters.push({
          field,
          filterType: type,
          value,
        });
      }
    },
    removeFilter: (state, action: PayloadAction<string>) => {
      state.activeFilters = state.activeFilters.filter(f => f.field !== action.payload);
    },
    clearAllFilters: state => {
      state.activeFilters = [];
    },
  },
});

export const { setFilter, removeFilter, clearAllFilters } = productsSlice.actions;

export const selectActiveFilters = (state: RootState) => state.products.activeFilters;

export const selectFilterByField = (field: string) => (state: { products: IProductsState }) =>
  state.products.activeFilters.find(f => f.field === field);

export const productsReducer = productsSlice.reducer;
